export default __webpack_public_path__ + "static/media/24-7-service.8fb5426e.png";